import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import AsyncSearchSelect from '../AsyncSearchSelect';
import { fetchCountiesByState } from '../../../../containers/CreationForms/AddEditWorkkard/store/addressApi';
import { useAddressSiblings } from '../utils/addressKeys';
import { getSectionFromKey, getAddressPlaceholder } from '../utils/addressLabels';

function normalizeCounties(response) {
  const items = response?.data || response?.suggestion || [];
  return items
    .filter((i) => i && i.county)
    .map((i) => ({ value: i.county, label: i.county }));
}

function CountyAsyncField({ config, value, onChange, onBlur, disabled, required, error }) {
  const { watch } = useFormContext();

  const section = useMemo(() => getSectionFromKey(config.fieldKey), [config.fieldKey]);
  const { stateKey, zipKey } = useAddressSiblings(config.fieldKey);

  const state = watch(stateKey);
  const zip = watch(zipKey);

  const placeholder = useMemo(
    () => config?.fieldSettings?.placeholder || getAddressPlaceholder({ role: 'county', section }),
    [config, section]
  );

  const fetchOptions = useMemo(() => {
    if (!state) return null;
    return async (q) => {
      try {
        const response = await fetchCountiesByState({ state, q });
        return normalizeCounties(response);
      } catch (err) {
        console.error('[CountyAsyncField] fetch failed:', err);
        return [];
      }
    };
  }, [state]);


  return (
    <AsyncSearchSelect
      config={config}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled || !zip}
      required={required}
      error={error}
      fetchOptions={fetchOptions}
      placeholder={placeholder}
      minChars={0}
      debounceMs={250}
      allowFreeText
    />
  );
}

export default CountyAsyncField;
